import swap from './swap'
import npxs from './npxs'

export default {
  swap: {
    address: '0x32Cac282752d86d260a88aeA596830CdBf12d2D1',
    abi: swap
  },
  npxs: {
    address: '0x64C69807efaD634cC3b2f46E3140be43c1Ed8aE0',
    abi: npxs
  }
}
